<template>
  <b-modal id="mass-attach-files-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow">
    <template #modal-title>
      <div class="d-flex">
        <span class="modal-title adp-h2 adp-h2__modal">{{ $t('idp.load_files') }}</span>
      </div>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template v-if="!isLoading">
      <div class="adp-p adp-p__grey adp-modal-row" v-html="$t('idp.attach_files_help')"></div>
      <div class="adp-p adp-p__grey adp-modal-row" v-html="$t('idp.select_learning_activity')"></div>

      <v-select :options="learningActivities" v-model="learningActivityId">
        <template #selected-option="option">
          <p style="height: 26px; overflow-y: hidden; line-height: 26px; font-size: 14px; color: #292929;">
            {{ option.label.length > 72 ? option.label.substr(0, 72) + '...' : option.label }}
          </p>
        </template>
        <template #option="option">
          <span class="adp-p" style="width: 100%; white-space: initial;">{{ option.label }}</span>
        </template>
        <template #no-options="{ search, searching }">
          <template v-if="searching">
            {{ $t('catalog.no_result_name') }} <em>{{ search }}</em>.
          </template>
          <span class="adp-p adp-p__grey" v-else>{{ $t('catalog.start_typing_for_search') }}</span>
        </template>
      </v-select>

      <div class="adp-p adp-p__grey adp-modal-row" v-if="learningActivityId" v-html="$t('idp.display_all_status_learning')" />

      <div class="d-flex flex-column" v-if="learningActivityId">
        <template v-for="(employee, i) in employeesVisible" style="height: 48px;">
          <div class="adp-modal-employee-link mt-5" @click="openInNewTab(employee.pernumber)">{{ employee.fullname }}</div>
          <div class="adp-modal-row d-flex flex-column">

            <div v-for="(file, i) in getEmployeeFiles(employee.pernumber)"
                 v-if="files.find(x => x.pernumber === employee.pernumber).files.length">
              <div class="adp-modal-files-block">
                <div class="adp-modal-files-block__icons">
                  <span class="adp-modal-files-block__icons rectangle"><img src="/images/rectangle.svg" alt=""></span>
                  <span class="adp-modal-files-block__icons paperclip"><img src="/images/paperclip.svg" alt=""></span>
                </div>
                <div class="adp-modal-files-block__title">
                  <div style="overflow: hidden; text-overflow: ellipsis; max-width: 400px">{{ file.name }}</div>
                </div>
                <div class="adp-modal-files-block__trash" @click="deleteFile(file, employee.pernumber)">
                  <img src="/images/trash.svg" alt="">
                </div>
              </div>
            </div>

            <b-form-file multiple :v-model="getEmployeeFiles(employee.pernumber)"
                         @input="addFile($event, employee.pernumber)"
                         :placeholder="$t('modal.files_input_placeholder')"
                         :drop-placeholder="$t('modal.drop_placeholder')" :id="`file-input-${employee.pernumber}`"/>
          </div>
        </template>
      </div>
    </template>
    <template #modal-footer>
      <button id="save" class="btn btn-primary adp-btn adp-btn__large" style="margin-left: auto" @click="save()">
        {{ $t('voc.save') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import api from "../../api";
import Vue from "vue";

export default {
  name: "MassAttachFilesModal",
  components: {
  },
  props: {
    employeesProps: {
      type: Object,
    },
  },
  data: function () {
    return {
      learningActivityId: null,
      learningActivities: [],
      employees: null,
      employeesVisible: null,
      isLoading: false,
      files: [],
      currentYear: new Date().getFullYear(),
    }
  },
  watch:{
    employees: {
      handler: function(newValue) {

      },
      deep: true
    },
    learningActivityId(newValue) {
      this.files = this.files.map(i => ({pernumber: i.pernumber, files: []}));

      let newEmployeesVisible = this.employees.filter(el => el.learning_activity_id === newValue.code);
      Vue.set(this, 'employeesVisible', newEmployeesVisible)

      this.onShow();
    }
  },
  methods: {
    onShow() {
      (async () => {
        this.isLoading = true;
        let res = await api.getLearningActivities(Object.keys(this.employeesProps), this.currentYear);
        this.employees = res.data.map(la => {
          let activity = Object.values(this.employeesProps).find(emp => emp.pernumber === la.pernumber)
          return {...la, ...activity}
        });

        this.files = [...new Set(Object.values(this.employees).map(e => e.pernumber))]
          .map(i => ({pernumber: i, files: []}));

        this.learningActivities = res.data
          .map((e) => {
            return {code: e.learning_activity_id, label: e.name, data: e}
          }).filter((v, i, a) => a.findIndex(t => (t.code === v.code)) === i);
        this.isLoading = false;
      })();
    },
    save() {
      try {
        return this.checkUploadFilesSize();
      } catch (e) {
        console.error(e.response.data);
        this.$toasts.error(JSON.stringify(e.response.data, null, 2), {
          duration: 700000,
        });
      }
    },
    checkUploadFilesSize() {
      let filesSizeIsCorrect = true;
      this.files.forEach(item => {
        if (!this.isFilesSizeCorrect(item.files)) filesSizeIsCorrect = false;
      })
      if (filesSizeIsCorrect) {
        this.files.forEach(item => {
          if (item.files.length) this.prepareDataForUpload(item);
        })
      } else {
        this.$toasts.error(this.$t('modal.big_file_error'), {
          duration: 700000,
        });
      }
    },
    isFilesSizeCorrect(filesArray) {
      let isSizeNormal = true;
      filesArray.forEach((file) => {
        if (file.size > 10000000) {
          isSizeNormal = false;
        }
      })
      return isSizeNormal;
    },
    prepareDataForUpload(item) {
      const formData = new FormData();
      const activityId = this.employeesVisible.find(i => i.pernumber === item.pernumber).idp_activity_id;

      item.files.map(file => formData.append(file.name, file, file.name));
      formData.append('user_pernumber', String(window.IDP.pernumber));
      formData.append('learning_activity_id', String(activityId));
      formData.append('role', String(this.$role));

      api.uploadFiles(formData);
      this.$emit('mass-attach-files');
    },
    getEmployeeFiles(pernumber) {
      return this.files.find(x => x.pernumber === pernumber).files;
    },
    addFile(files, pernumber) {
      this.files.find(x => x.pernumber === pernumber).files.push(...files);
    },
    deleteFile(file, pernumber) {
      let employeeFiles = this.getEmployeeFiles(pernumber);
      this.files.find(x => x.pernumber === pernumber).files = employeeFiles.filter((item) => item !== file);
    },
    openInNewTab(pernumber) {
      let routeData = this.$router.resolve({ name: `${this.$role}-employee`, params: { pernumber: pernumber }});
      window.open(routeData.href, '_blank');
    },
  },
}
</script>
